module.exports = __webpack_public_path__ + "img/title.259c9420.png";